import { useMemo } from 'react';

import { useRootDocument } from '~/core/shared/hooks';
import { WorkflowStepFormFieldBlock } from '~/core/shared/types';
import { getDefaultValuesForFormFields } from '../logic/getDefaultValuesForFormFields';

export const useDefaultValuesForFormFields = (
  formFieldBlocks: WorkflowStepFormFieldBlock[],
  documentPath?: string[],
) => {
  const rootDocument = useRootDocument();

  const defaultValues = useMemo(
    () =>
      getDefaultValuesForFormFields(
        formFieldBlocks,
        rootDocument,
        documentPath,
      ),
    [formFieldBlocks, rootDocument, documentPath],
  );

  return defaultValues;
};
